import { DestinationAccountControllerType } from "../useDestinationAccount";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { FormContainer } from "./styles";
import { TitleLarge } from "../../../components/font";
import { TextField, SearchableDropdown, Button } from "@manifesthhqinc/ui-library";
import Footer from "../../../components/footer";
import HeadingContainer from "../../../layout/heading-container";

const ESDetails = (props: DestinationAccountControllerType) => {
  const { currentDestinationDetails, updateDestinationDetails, providerList, onClickContinue, formValidation } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="confirm-destination-account">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge $textAlign="left">Got it! We need a few details to help verify your account</TitleLarge>
          </HeadingContainer>
          <FormContainer>
            <SearchableDropdown
              dropdownIndicator
              name="accountProvider"
              title="Account provider"
              value={currentDestinationDetails.providerName}
              onChange={(e) => updateDestinationDetails({ providerName: e?.label || "" })}
              options={providerList.map((provider) => ({ label: provider, value: provider }))}
              size="large"
              errorText={formValidation.providerName}
            />
            <TextField
              name="planName"
              value={currentDestinationDetails.planName || ""}
              onChange={(e) => updateDestinationDetails({ planName: e.target.value || "" })}
              title="Plan name (optional)"
              size="large"
              errorText={formValidation.planName || undefined}
            />
          </FormContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={onClickContinue} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ESDetails;
